module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("popup_container", [["div",{"class":"guiLargePopup popup hidden"},[["span",{"class":"inf-icon_close_10 cross close"}],["div",{"class":"widgetContainer","id":"popup-widget-container"}]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/popup.tpl
// module id = 1058
// module chunks = 4